/**
 * SEO tags in the Head
 */

import React from "react" 
import { Helmet } from "react-helmet"
 const YoastSEO = (props) => {
     //console.log(props);
     const wpSiteID = props.wpSiteID;
     const wpContentType = props.wpContentType;
     const yoastSeo = props.data;
     const metaRobots = 'max-snippet:-1, max-image-preview:large, max-video-preview:-1';
     let metaDesc = '';
     if (yoastSeo && yoastSeo.metaDesc){
      metaDesc =  yoastSeo.metaDesc;
     } else {
      metaDesc = ''
     }

     let metaKw = '';
     if (yoastSeo && yoastSeo.focuskw){
      metaKw =  yoastSeo.focuskw;
     } else {
      metaKw = '';
     }

     let title = '';
     if (yoastSeo && yoastSeo.title){
        title =  yoastSeo.title;
       } else {
        title = props.title + ' | BETA - South Gloucestershire Council'
       }

 return ( 

    <Helmet>
        <meta name="siteimprove-contentid" value={wpSiteID}/>
        <meta name="siteimprove-typing" value={wpContentType}/>
        <meta name="description" content={metaDesc}/>
        <meta name="keywords" content={metaKw}/>
        <title>{title}</title>
    </Helmet>
  
 ) 
} 
export default YoastSEO